import { TablesChooserStore } from "./store";

export function initTablesChooserStore() {
    new TablesChooserStore();
}
